<small class="form-agreement">
  <ng-content></ng-content>
</small>
